import React, { useLayoutEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";

type EllipsisTooltipProps = {
  text: React.ReactNode;
  maxWidth?: number | string;
  className?: string;
};

export const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({
                                                                  text,
                                                                  maxWidth = "100%",
                                                                  className,
                                                                }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useLayoutEffect(() => {
    const checkOverflow = () => {
      const el = ref.current;
      if (!el) return;
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => observer.disconnect();
  }, [text]);

  const content = (
    <span
      ref={ref}
      className={className}
      style={{
        display: "block",
        maxWidth,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );

  return isOverflowed ? (
    <Tooltip title={text} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
